module.exports = __webpack_public_path__ + "static/media/O1_ROUGH.1ddd24d2.png";